import { AgGrid } from "@jsq/ds/core";
import { globalEnv } from "~/global-env";
import { ComplianceCaseTypeEnum } from "~/graphql/supergraphEnums";
import { ExternalLinkCountCellRenderer } from "../ExternalLinkCountCellRenderer";

export const EscalationsCellRenderer = ({ data }: AgGrid.ICellRendererParams) => {
  const escalationCaseIds =
    data?.escalationCaseIds ??
    data?.activeCases
      ?.filter(
        (caseInfo: { caseType: ComplianceCaseTypeEnum }) =>
          caseInfo.caseType === ComplianceCaseTypeEnum.Escalation,
      )
      .map((caseInfo: { id: number }) => caseInfo.id) ??
    [];

  return (
    <ExternalLinkCountCellRenderer
      count={escalationCaseIds.length}
      launchLink={`${globalEnv.complianceRoute}/escalations?escalationIds=${escalationCaseIds.join(",")}`}
      tooltipContent="View cases"
      testIdPrefix="view-escalation-cases"
    />
  );
};
